module.exports = __webpack_public_path__ + "img/2.560dda9a.jpg";